import { render, staticRenderFns } from "./AppGridFooter.vue?vue&type=template&id=f5ee5f44&"
import script from "./AppGridFooter.vue?vue&type=script&lang=js&"
export * from "./AppGridFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports